import request from "@/plugins/axios.js";

const login = (data) => {
    return request({
        url: "/User/logon_gr",
        method: "post",
        data,
    });
};
const sendCode = (data) => {
    return request({
        url: "/User/sendYzm",
        method: "post",
        data,
    });
};
// 注册
const register = (data) => {
    return request({
        url: "/User/doNewRegister",
        method: "post",
        data,
    });
};
// 获取登录图形验证码
const getAuthCode = (data) => {
    return request({
        url: "/User/getAuthCode",
        method: "post",
        data,
    });
};
// 发送手机验证码
const sendYzm = (data) => {
    return request({
        url: "/User/sendYzm",
        method: "post",
        data,
    });
};
// 找回密码
const findPwd = (data) => {
    return request({
        url: "/User/findPwd",
        method: "post",
        data,
    });
};
// 修改密码
const modifyPwd = (data) => {
    return request({
        url: "/User/modifyPwd",
        method: "post",
        data,
    });
};
// 检测用户
const checkUser = (data) => {
    return request({
        url: "/User/checkUser",
        method: "post",
        data,
    });
};
export default {
    login,
    sendCode,
    register,
    getAuthCode,
    sendYzm,
    findPwd,
    modifyPwd,
    checkUser
};
